// extracted by mini-css-extract-plugin
export default {"input":"Input_input__bQhIW","iconInsideLeft":"Input_iconInsideLeft__lYDso","iconInsideRight":"Input_iconInsideRight__XQ48v","inputfile":"Input_inputfile__N3LOr"};